import { createSelector } from 'reselect';
import { createDisplayLayoutSelector } from '../../selectors/display-layout-selector.esm.js';

function getSelectedOptions(layout) {
  var _layout$fields;
  if (!(layout !== null && layout !== void 0 && (_layout$fields = layout.fields) !== null && _layout$fields !== void 0 && _layout$fields.length)) {
    return [];
  }
  return layout === null || layout === void 0 ? void 0 : layout.fields.map(function (f) {
    return f.toString();
  });
}
var createSelectedOptionsSelector = function createSelectedOptionsSelector() {
  var displayLayoutSelector = createDisplayLayoutSelector();
  return createSelector(displayLayoutSelector, getSelectedOptions);
};

export { createSelectedOptionsSelector };
//# sourceMappingURL=selected-options-selector.esm.js.map
